import React from 'react';
import CourseDetails from '../components/courseDetails/index';

export default function CourseDetailsPage() {
    return <CourseDetails />;
}
